import { Navigate, useParams } from "react-router-dom";

const RESERVED = new Set([
  "login",
  "register",
  "dashboard",
  "tickets",
  "clients",
  "channels",
  "teams",
  "agents",
  "profile",
  "settings",
  "assinatura",
  "cliente",
  "knowledge-base",
  "api",
  "v1",
]);

/** Acessar só /bytefy → redireciona para /bytefy/cliente/login */
export default function TenantPortalRedirect() {
  const { tenant } = useParams<{ tenant: string }>();
  const t = tenant?.trim().toLowerCase() ?? "";
  if (!t || RESERVED.has(t)) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={`/${encodeURIComponent(t)}/cliente/login`} replace />;
}
